import React from 'react'
import { graphql } from 'gatsby'
import style from './icon.mod.scss'

const Icon = ({ image, title, url, externalLink = false }) => {
  return (
    <a
      href={url}
      className={style.icon}
      target={externalLink && '_blank'}
      rel={externalLink && 'noopener noreferrer'}
    >
      <img src={image.url} alt={`${title} icon`} />
      {title && <h4>{title}</h4>}
    </a>
  )
}

export default Icon

export const query = graphql`
  fragment SocialLink on DatoCmsSocialLink {
    id
    icon {
      url
    }
    title
    url
  }
`
